import React from "react";
import {
    TextInput,
    SelectInput,
    DateInput,
    ArrayInput,
    SimpleFormIterator
} from 'react-admin';
import required from "../helper/Required";
import CustomAddButton from "./CustomAddButton";
import CustomRemoveButton from "./CustomRemoveButton";

class DocumentArrayInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayInput
                {...this.props}
                // defaultValue={[
                //     {
                //         type: "",
                //         number: "",
                //         issuedBy: "",
                //         issuedAt: ""
                //     }
                // ]}
            >
                <SimpleFormIterator addButton={<CustomAddButton />} removeButton={<CustomRemoveButton />}>
                    <SelectInput label="Тип документу" source="type" validate={required.validateRequired} choices={
                       this.props.shortList ?
                           [
                               { id: 'PASSPORT', name: 'Паспорт громадянина України' },
                               { id: 'NATIONAL_ID', name: 'Біометричний паспорт громадянина України' },
                               { id: 'PERMANENT_RESIDENCE_PERMIT', name: 'Посвідка на постійне проживання в Україні' },
                               { id: 'TEMPORARY_CERTIFICATE', name: 'Посвідка на проживання' },
                               { id: 'TEMPORARY_PASSPORT', name: 'Тимчасове посвідчення громадянина України' }
                           ] :
                           [
                               { id: 'PASSPORT', name: 'Паспорт громадянина України' },
                               { id: 'NATIONAL_ID', name: 'Біометричний паспорт громадянина України' },
                               { id: 'PERMANENT_RESIDENCE_PERMIT', name: 'Посвідка на постійне проживання в Україні' },
                               { id: 'TEMPORARY_CERTIFICATE', name: 'Посвідка на проживання' },
                               { id: 'TEMPORARY_PASSPORT', name: 'Тимчасове посвідчення громадянина України' },
                               //{ id: 'BIRTH_CERTIFICATE', name: 'Свідоцтво про народження (для осіб, які не досягли 14-річного віку)' },
                               //{ id: 'BIRTH_CERTIFICATE_FOREIGN', name: 'Свідоцтво про народження іноземного зразку' },
                               { id: 'COMPLEMENTARY_PROTECTION_CERTIFICATE', name: 'Посвідчення особи, яка потребує додаткового захисту' },
                               //{ id: 'REFUGEE_CERTIFICATE', name: 'Посвідка біженця' }
                           ]
                    } />
                    <TextInput label="Номер документу" source="number" validate={required.validateRequired} />
                    <TextInput label="Ким виданий" source="issuedBy" validate={required.validateRequired} />
                    <DateInput label="Дата видачі" source="issuedAt" validate={required.validateRequiredDate} />
                </SimpleFormIterator>
            </ArrayInput>
        );
    }
}

export default DocumentArrayInput;
